import {HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {LatestPatchNoteDto} from '../../../models/client';
import {HttpIdentityLocationApiService} from '../http/http-location-api/http-location-api.service';

@Injectable({
    providedIn: 'root'
})
export class PatchNoteService {

    constructor(
        private http: HttpIdentityLocationApiService
    ) {
    }

    public async getLatest(newVersion: string, oldVersion: string): Promise<LatestPatchNoteDto> {
        const params = new HttpParams()
            .set('newVersion', newVersion)
            .set('oldVersion', oldVersion)
            .set('client', '2');

        const response = await this.http.get<LatestPatchNoteDto>(
            'v2/patchnote/latest',
            null,
            params
        ).toPromise();

        return response.body;
    }
}
